// extracted by mini-css-extract-plugin
export default {"main_wrap":"NoticeListPage_main_wrap__4nySq","title":"NoticeListPage_title__VERjR","date":"NoticeListPage_date__0Vr8D"};